import { post } from "./base";

export async function commitImpressionText(courseId, impression) {
    let params = {courseId, feeling: impression};
    let respObj = await post("/system/record/addFelling", params);
    return respObj;
}